<template>
  <div>
    <component
      :is="showH5Style ? 'el-drawer' : 'el-dialog'"
      title=""
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :custom-class="showH5Style ? 'h5-notes-dialog' : 'notes-dialog'"
      :direction="showH5Style ? 'btt' : ''"
      :close-on-click-modal="false"
      :wrapper-closable="false"
    >
      <div class="header-wrap">
        <p class="title">添加备注</p>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="dialog-cont-wrap">
        <!-- @focus="handleFocus" -->
        <el-input
          ref="myInput"
          class="notes-input"
          type="textarea"
          placeholder="请填写您的要求"
          v-model.trim="text"
          maxlength="50"
          show-word-limit
          resize="none"
        >
        </el-input>
        <div class="operate-wrap">
          <button @click="handleClose" v-preventReClick class="cancel-btn">
            取消
          </button>
          <button v-preventReClick class="submit-btn" @click="handleSubmit">
            确认
          </button>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import { isH5, isMGAppInPad } from "@saas/components/src";
export default {
  data() {
    return {
      dialogVisible: false,
      isH5: isH5(),
      text: "",
      isMGAppInPad: isMGAppInPad(),
      showH5Style: false,
    };
  },
  created() {
    this.showH5Style = this.isH5 && !this.isMGAppInPad;
  },
  methods: {
    // handleFocus() {
    //   setTimeout(() => {
    //     this.$refs?.myInput?.$el?.scrollIntoView(false);
    //   }, 300);
    // },
    handleClose(done) {
      this.$refs?.myInput?.blur();
      this.dialogVisible = false;
    },
    openDialog(text) {
      this.text = text;
      this.dialogVisible = true;
    },
    handleSubmit() {
      this.$emit("submit", this.text);
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .notes-dialog,
::v-deep .h5-notes-dialog {
  --notes-dialog-bg: var(--mg-bg-card);
  --notes-dialog-title: var(--mg-text-primary);
  --notes-dialog-secondary: var(--mg-text-secondary);
  --notes-dialog-border: var(--mg-border-subtle);
  --notes-dialog-input-bg: var(--mg-control-hover-bg);
  --notes-dialog-input-text: var(--mg-text-primary);
  --notes-dialog-placeholder: var(--mg-text-muted);
  --notes-dialog-cancel-bg: var(--mg-disabled-bg);
  --notes-dialog-cancel-text: var(--mg-text-primary);

  html.dark & {
    --notes-dialog-bg: var(--mg-bg-surface);
    --notes-dialog-input-bg: var(--mg-bg-card);
    --notes-dialog-cancel-bg: var(--mg-control-hover-bg);
  }
}

::v-deep .notes-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  width: 375px;
  border-radius: 12px;
  background: var(--notes-dialog-bg);
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    height: 282px;
    padding: 0;
    background: var(--notes-dialog-bg);
    border-radius: 12px;
  }
  .header-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    border-bottom: 1px solid var(--notes-dialog-border);
    padding: 0 12px;
    font-weight: 500;
    font-size: 15px;
    color: var(--notes-dialog-title);
    line-height: 21px;
    i {
      position: absolute;
      top: 15px;
      right: 15px;
      font-size: 16px;
      font-weight: 500;
      color: var(--notes-dialog-secondary);
      cursor: pointer;
    }
  }
  .dialog-cont-wrap {
    padding: 12px 12px 0;
  }
  .notes-input {
    .el-textarea__inner {
      height: 131px;
      background: var(--notes-dialog-input-bg);
      border-radius: 12px;
      border: none;
      font-size: 15px;
      color: var(--notes-dialog-input-text);
      &::placeholder {
        font-size: 15px;
        color: var(--notes-dialog-placeholder);
      }
    }
    .el-input__count {
      background: var(--notes-dialog-input-bg);
      font-size: 15px;
      color: var(--notes-dialog-secondary);
    }
  }
  .operate-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
  }
  .cancel-btn,
  .submit-btn {
    width: 165px;
    height: 50px;
    border-radius: 12px;
    font-weight: 500;
    font-size: 16px;
    color: var(--notes-dialog-cancel-text);
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--notes-dialog-cancel-bg);
  }
  .submit-btn {
    color: #ffffff;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  }
}
::v-deep .h5-notes-dialog {
  height: 7.51rem !important;
  background: var(--notes-dialog-bg);
  #el-drawer__title {
    display: none;
  }
  .el-drawer__body {
    background: var(--notes-dialog-bg);
  }
  .header-wrap {
    position: relative;
    height: 1.17rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 0.4rem;
    color: var(--notes-dialog-title);
    line-height: 0.56rem;
    border-bottom: 0.03rem solid var(--notes-dialog-border);
    i {
      position: absolute;
      top: 0.4rem;
      right: 0.4rem;
      font-size: 0.4rem;
      color: var(--notes-dialog-secondary);
    }
  }
  .dialog-cont-wrap {
    padding: 0.32rem 0.32rem 0;
  }
  .notes-input {
    .el-textarea__inner {
      height: 3.48rem;
      background: var(--notes-dialog-input-bg);
      border-radius: 0.32rem;
      border: none;
      font-size: 0.4rem;
      color: var(--notes-dialog-input-text);
      &::placeholder {
        font-size: 0.4rem;
        color: var(--notes-dialog-placeholder);
      }
    }
    .el-input__count {
      background: var(--notes-dialog-input-bg);
      font-size: 0.4rem;
      color: var(--notes-dialog-secondary);
    }
  }
  .operate-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 0.67rem;
  }
  .cancel-btn,
  .submit-btn {
    width: 4.4rem;
    height: 1.33rem;
    border-radius: 0.32rem;
    font-weight: 500;
    font-size: 0.43rem;
    color: var(--notes-dialog-cancel-text);
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--notes-dialog-cancel-bg);
  }
  .submit-btn {
    color: #ffffff;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  }
}
</style>
